import usersReducer from "./add-user/slice";
import signInReducer from "./signin/slice";
import userReducer from "./users/slice";
import rolesReducer from "./roles/slice";
import clientsReducer from "./clients/slice";
import inspectionFirmsReducer from "./inspection-firms/slice";
import formTemplatesReducer from "./form-templates/slice";
import ordersReducer from "./orders/slice";
import propertyReducer from "./properties/slice";
import locationReducer from "./locations/slice";

const rootReducers = {
  users: usersReducer,
  signIn: signInReducer,
  user: userReducer,
  roles: rolesReducer,
  clients: clientsReducer,
  inspectionFirms: inspectionFirmsReducer,
  formTemplates: formTemplatesReducer,
  orders: ordersReducer,
  property: propertyReducer,
  location: locationReducer,
};

export default rootReducers;
